export const CREATE_POOL_REQUEST_FAILURE = 'CREATE_POOL_REQUEST_FAILURE';

export const createPoolRequestFailure = error => ({
    type: CREATE_POOL_REQUEST_FAILURE,
    payload: error,
    error: true,
});
